<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
       style="height:50vh;overflow-y:scroll"
    >
      <!-- <el-form-item label="登录账号：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.loginId"
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="人员编号：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.number"
          disabled
          size="small"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="名称：" prop="userName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.userName"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属角色：" prop="roleId">
        <el-select
          style="width:95%"
          v-model="ruleForm.roleId"
          size="small"
          placeholder="请选择所属角色"
        >
          <el-option
            v-for="item in roleListData"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码:" prop="userPhone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.userPhone"
          placeholder="请输入手机号码"
          size="small"
          :maxlength="32"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="密码：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.userPwd"
          placeholder="若不更改密码请勿填，密码不少于6位"
          clearable
          auto-complete="new-password"
          show-password
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属部门：" prop="departmentId">
        <el-select
          style="width:95%"
          v-model="ruleForm.departmentId"
          size="small"
          placeholder="请选择所属部门"
        >
          <el-option
            label="请选择所属部门"
            :value="0"
          ></el-option>
          <el-option
            v-for="item in departmentList"
            :key="item.departmentId"
            :label="item.departmentName"
            :value="item.departmentId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职务：" prop="officeId">
        <el-select
          style="width:95%"
          v-model="ruleForm.officeId"
          size="small"
          multiple
          :popper-append-to-body="false"
          placeholder="请选择职务"
        >
          <el-option
            v-for="item in jobListData"
            :key="item.id"
            :label="item.positionTitle"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证号:">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.userIdNumber"
          placeholder="请输入身份证号"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select
          style="width:95%"
          v-model="ruleForm.sex"
          size="small"
          placeholder="请选择性别"
        >
          <el-option
            v-for="item in personnelSex"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="座机:">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.landlineNumber"
          placeholder="请输入座机号码"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱:">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.email"
          placeholder="请输入邮箱"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="头像:">
        <head-portrait-up-load
          :imageUrl="ruleForm.headPortrait"
          @imageChange="imageChange"
        ></head-portrait-up-load>
      </el-form-item>
      <el-form-item label="设为领导：" prop="leaderOrNot">
        <el-select
          style="width:95%"
          v-model="ruleForm.leaderOrNot"
          size="small"
          placeholder="是否设为领导"
        >
          <el-option
            v-for="item in orLead"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
  
    </el-form>
        <div style="text-align:right">
    <span slot="footer" size="large">
        <el-button type="primary" size="small" @click="saveSubmit('ruleForm')"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="cencelSubmit('ruleForm')"
          >取消</el-button
        >
      </span>
    </div>
  </div>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "TeacherInfoEdit",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    },
    roleListData: {
      //所属角色列表
      type: Array,
      default: {
        return: []
      }
    },
    departmentList: {
      //所属部门列表
      type: Array,
      default: {
        return: []
      }
    },
    jobListData: {
      //职务
      type: Array,
      default: {
        return: []
      }
    },
    editBox: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
    var checkIdCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!idcard_patter.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      ruleForm: this.defaultData,
      rules: {
        roleId: [
          { required: true, message: " ", trigger: "change" }
        ],
        userName: [
          { required: true, message: " ", trigger: "blur" },
          { min: 1, max: 24, message: " ", trigger: "blur" }
        ],
        userPhone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        userPwd: [
          { required: true, message: " ", trigger: "blur" },
          { min: 1, max: 24, message: " ", trigger: "blur" }
        ],
        departmentId: [
          { required: true, message: " ", trigger: "change" }
        ],
        officeId: [
          { required: true, message: " ", trigger: "change" }
        ],
        userIdNumber: [
          { required: true, validator: checkIdCard, trigger: "blur" }
        ],
        sex: [{ required: true, message: " ", trigger: "change" }],
        landlineNumber: [
          { required: true, message: " ", trigger: "blur" },
          { min: 1, max: 24, message: " ", trigger: "blur" }
        ],
        email: [
          { required: true, message: " ", trigger: "blur" },
          {
            type: "email",
            message: " ",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  computed: {
    personnelSex() {
      return this.$store.state.select.personnelSex;
    },
    orLead() {
      return [
        { id: 0, name: "不是领导" },
        { id: 1, name: "是领导" }
      ];
    }
  },
  mounted() {},
  methods: {
    //   提交
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("editSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   取消
    cencelSubmit(formName) {
      this.$refs[formName].resetFields();
      this.$emit("editCencel");
    },
    imageChange(src) {
      this.ruleForm.headPortrait = src || "";
    }
  },
  watch: {
    editBox: function(val) {
      if (val) {
        this.ruleForm = Object.assign({}, this.defaultData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
